import { useTheme } from "@material-ui/core";
import React from "react";
import { Filter as RaFilter, ReferenceInput, SelectInput } from "react-admin";
import approvalStatuses from "../bookmaker-approvals/statuses";
import statuses from "../bookmakers/statuses";
import SearchInput from "../components/inputs/SearchInput";
import { useFiltersStyles } from "../components/lists/useStyles";

const Filters = (props) => {
	const theme = useTheme();
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes} variant="outlined">
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="language_id"
				reference="languages"
				alwaysOn
				fullWidth
				style={{ marginTop: theme.spacing(4) }}
				sort={{ field: "id", direction: "ASC" }}
				filter={{ is_frontend: true }}
				emptyText="ra.action.allf"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="status"
				choices={statuses}
				alwaysOn
				fullWidth
			/>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="user_status"
				choices={[
					{
						id: "none",
						name: "resources.deals.actions.promote",
					},
					...approvalStatuses,
				]}
				alwaysOn
				fullWidth
			/>
		</RaFilter>
	);
};
export default Filters;
